import HomePage from "../post";

export default function Indexpage() {
  return (
    <>
      <HomePage />
      
    </>
  );
}
